export enum OrderSide {
    BUY = 'B',
    SELL = 'S',
    SUBSCRIPTION = 'U',
    REDEEM = 'R'
}

export enum OrderSideChar {
    B = 'buy',
    S = 'sell',
    U = 'subscription',
    R = 'redemption'
}